import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 6H3v12h18V6zm-2 10H5V8h14v8z"
}), 'Crop169Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop169Sharp.js
// module id = 2987
// module chunks = 2